
import { defineComponent, inject } from 'vue';
import { useVModel } from 'vue-composable';
import { WarningOutline as WarningIcon } from '@vicons/ionicons5';
import { User } from '@/types';
import userService from '@/services/user-service';
import { ShowToast } from '@/providers/Toast/toast-types';

export default defineComponent({
  name: 'ConfirmUserDeleteModal',
  props: {
    user: {
      type: Object as () => User | null,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  components: { WarningIcon },
  setup(props, { emit }) {
    const showModalRef = useVModel(props, 'showModal');
    const showToast = inject<ShowToast>('showToast')!;
    const confirmDelete = () => {
      userService
        .delete(props.user?.id ?? '')
        .then(() => {
          emit('user-delete', props.user?.id);
          showToast({
            headline: 'Success',
            message: 'User deleted',
            color: 'success'
          });
        })
        .catch(() => {
          showToast({
            headline: 'Error',
            message: 'Failed to delete user',
            color: 'danger'
          });
        })
        .finally(() => {
          showModalRef.value = false;
        });
    };

    const cancelDelete = () => {
      showModalRef.value = false;
    };

    return {
      confirmDelete,
      cancelDelete,
      showModalRef
    };
  }
});
